import { useContext, useState } from "react";

import type { PluginContextData } from "./provider";
import { PluginContext } from "./provider";

export const usePluginContext = (): PluginContextData & {
  isLoading: boolean;
} => {
  const context = useContext(PluginContext);
  const [loading, setLoading] = useState<boolean>(false);

  if (!context) {
    throw new Error(
      "usePluginContext must be used within the context, check your PluginContext provider",
    );
  }

  const { loadScript } = context;
  const handleLoadScript = async (url: string): Promise<void> => {
    const container = document.getElementById("plugin-container");
    const script = container?.querySelector<HTMLScriptElement>(
      `script[src="${url}"]`,
    );

    if (script?.dataset.loaded === "true") {
      return;
    }

    setLoading(true);
    try {
      await loadScript(url);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return { ...context, isLoading: loading, loadScript: handleLoadScript };
};
